<div class="row">
    <div 
        *ngFor="let resultado of resultados"
        class="col-md-4 col-sm-6 animate__animated animate__fadeIn"
    >
        <div class="card">
            <img 
                [src]="resultado.images.downsized_medium.url" 
                [alt]="resultado.title"
                class="card-img-top"
            >
            <div class="card-body">
                <p class="card-text">
                    {{resultado.title}}
                </p>
            </div>
        </div>
    </div>
</div>